module.exports = __webpack_public_path__ + "img/dashboard.3eba5aed.png";